<template>
  <div class="rich-text-main position-r">
    <editor id="myEditor" ref="editor" v-model="suggestInfo.highlight || formData.description"
            :init="{...init, placeholder: editorPlaceholder}">
    </editor>
		<ai-resume-optimization
			@useOptimizationContent="useOptimizationContent"
			@handleSaveCurrentForm="handleSaveCurrentForm"
		></ai-resume-optimization>
    <suggest-card v-if="suggestInfo.suggest && (suggestInfo.field === 'description' || !suggestInfo.field)" :top="226"
                  @handleClose="handleClose"></suggest-card>
  </div>
</template>
<script>
	import tinymce from 'tinymce/tinymce'
	import Editor from '@tinymce/tinymce-vue'
	import 'tinymce/themes/silver'
	import 'tinymce/plugins/lists'// 列表插件
	import 'tinymce/plugins/link'
	import 'tinymce/icons/default'
	import 'tinymce/plugins/paste'
	import suggestCard from '../../../../../components/editor/suggest-card'
	import aiResumeOptimization from './ai-resume-optimization.vue'
	import { mapState, mapMutations } from 'vuex'

	export default {
		name: 'text-editor',
		props: {
			baseUrl: {
				type: String,
				default: process.env.NODE_ENV === 'development' ? '' : process.env.OSS
			},
			formData: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data () {
      // let that = this
			return {
				content: '',
        listenerDom: null,
				init: {
					language_url: `${ this.baseUrl }/tinymce/langs/zh_CN.js`,
					language: 'zh_CN',
					skin_url: `${ this.baseUrl }/tinymce/skins/ui/oxide`,
					content_css: `${ this.baseUrl }/tinymce/skins/content/default/content.css`,
					height: 218,
					plugins: 'lists link paste anchor',
					toolbar: 'undo redo bold italic bullist numlist outdent indent link removeformat anchor',
					toolbar_sticky: true,
					branding: false,
					menubar: false,
					paste_remove_styles_if_webkit: true,
					paste_remove_styles: true,
					contextmenu: false,
					paste_as_text: true,
					paste_word_valid_elements: 'b,strong,em,li,ul,ol,p',
					placeholder: '',
          // 粘贴监听
          // setup: function (editor) {
          //   console.log(editor,"=====================>editor");
          //   editor.on('paste', (e) => {
          //     // Prevent default paste behavior
          //     e.preventDefault();
          //
          //     // Check for clipboard data in various places for cross-browser compatibility.
          //     // Get that data as text.
          //     let content = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
          //     // Let TinyMCE do the heavy lifting for inserting that content into the editor.
          //     editor.execCommand('mceInsertContent', false, content);
          //   })
          // }
				},
				editorTimer: null
			}
		},
		computed: {
			...mapState('editor', [ 'currentInfo', 'cvDetail', 'suggestInfo', 'textEditorScrollTop' ]),
			// text editor placeHolder
			// eslint-disable-next-line vue/return-in-computed-property
			editorPlaceholder () {
				let { basic_info: { cv_type } } = this.cvDetail
				let { type } = this.currentInfo
				type = typeof type === 'number' ? 'custom' : type
				switch (type) {
					case 'personal_summary':
						if (cv_type.includes('grad')) {
							return '简短分条地总结与申请专业相关的经验、技能以及能力'
						} else {
							return '简短分条地总结与申请岗位相关的经验、技能以及能力'
						}
					case 'project_experience':
						if (cv_type.includes('programmer')) {
							return '简要说明参与开发的项目，附加超链接，展现自己的专业能力'
						} else {
							return '介绍在什么样项目中自己负责的内容，列出通过什么动作或技能达到了什么成果（最好是可量化的）'
						}
					case 'reasearch_experience':
						return '介绍研究项目如毕业论文，小组项目等，描述负责的具体内容，以及最终的项目成果，受到导师好评、获奖情况等'
					case 'skill_list':
						return '按照 “技能领域：编程语言（掌握程度）” 的格式罗列专业技能，如：Web开发：Python（熟练）'
					case 'custom':
						return '介绍在什么经历中，通过某些活动或技能，达到了什么样的成果'
					case 'edus':
						return '可以列出成绩、荣誉奖项、相关课程等'
					case 'works':
						return '简短介绍公司与自己负责的任务，分条罗列在什么项目中，通过某些动作或技能达到可量化的结果'
					case 'orgs':
						return '介绍在什么活动中自己负责的内容，列出通过什么动作获得了什么成果'
				}
			},
		},
		watch: {

    },
		components: {
			// quillEditor
			Editor,
			suggestCard,
			aiResumeOptimization
		},
		mounted () {
			this.initEditor()
		},
		methods: {
			...mapMutations('editor', [ 'setSuggestInfo', 'setTextEditorScrollValue', 'upateAuxiliaryPackup' ]),
      // 粘贴事件监听
      // pasteEvent(e) {
      //   e.preventDefault();
      //   let copyText = (e.clipboardData || window.clipboardData).getData('text');
      // },
			// 函数防抖
			debounce (fn, timeInterval) {
				if (this.editorTimer) {
					clearTimeout(this.editorTimer)
				}
				let arg = [ ...arguments ].filter((item, index) => {
					return index > 1
				})
				this.editorTimer = setTimeout(() => {
					fn.apply(this, arg)
				}, timeInterval)
			},
			handleClose () {
				this.setSuggestInfo({})
			},
			initEditor () {
				const fn = () => {
					this.debounce(() => {
						let contentWindow = document.querySelector('.tox-edit-area__iframe').contentWindow
						let textEl = contentWindow.document.querySelector('#tinymce')
						if (textEl.clientHeight > 180) {
							let editorEl = document.querySelector('.tox-tinymce')
							editorEl.style.transition = `all .1s`
							editorEl.style.height = `${ textEl.clientHeight + 38 }px`
						}
					}, 100)
				}
				if (this.suggestInfo.suggest) {
					tinymce.activeEditor.on('focus', () => {
						this.handleClose()
					})
				}
				tinymce.activeEditor.on('focus', (e) => {
					let { type } = this.currentInfo
          let containerHeight = document.querySelector('.edit-module-content-main ').clientHeight
					let scrollEl = document.querySelector(`.edit-module-index-main`)
					let el = document.querySelector('.text-editor-content')
					let top = type === 'skill_list' || type === 'personal_summary' ? 0 : type === 'project_experience' ? 310 : 390
          console.log(top)
					setTimeout(() => {
            scrollEl.scrollTo({ top, behavior: 'smooth' })
          },200)
          this.upateAuxiliaryPackup(true)
				})
				tinymce.activeEditor.on('input', fn)
				tinymce.activeEditor.on('paste', fn)
			},
			useOptimizationContent(result) {
				this.$emit('useOptimizationContent', result);
			},
			handleSaveCurrentForm(result) {
				this.$emit('handleSaveCurrentForm', result);
			}
		}
	}
</script>
<style scoped lang="scss">
  .rich-text-main {
    // height: 260px;
    // padding-bottom: 20px;
    .tox-statusbar {
      display: none;
    }
    /deep/ .tox-tinymce {
      border-radius: 4px;
    }
    ::v-deep {
      .tox-editor-container.auto {
        padding-top: 0 !important;
      }
      .tox-editor-header.auto {
        position: static !important;
        width: auto !important;
        box-shadow: none !important;
      }
    }
  }
</style>
